module.exports = __webpack_public_path__ + "static/sre-logo-643f04a23119db9a3c0bf1d186053625.png";